<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :loading="loading"
      size="1200x580"
      :visible.sync="modalVisible"
  >
    <template #content>
      <gj-button class="guanbi" type="icon" plain @click="cancel">
        <i class="iconfont iconguanbi-da"></i>
      </gj-button>

      <gj-carousel
          ref="carousel"
          :list="['batch']"
          :loop="true"
          :autoplay="true"
          :interval="5000"
          arrow="hover"
          height="580px"
          indicatorPosition="none"
      >
        <template #batch>
          <div class="content flex flex-direction-column align-center">
            <el-image :src="stepImgs[0]" class="img"></el-image>
          </div>
        </template>

      </gj-carousel>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "@/minxins";

export default {
  name: "nrnf-notice",
  mixins: [modalMixIn],
  data() {
    return {
      loading: false,
      stepImgs: [
        require('@/assets/images/notice/notice.png'),
      ],

    }
  },
  methods: {
    cancel() {
      this.modalVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/styles/variables.scss';

/deep/ .el-dialog__body {
  padding: 0 !important;
}

/deep/ .is-active {
  .el-carousel__button {
    background-color: $gj-color-primary;
  }
}

/deep/ .el-carousel__button {
  width: 35px;
  height: 3px;
  background-color: $gj-line-color-grey4;
  border-radius: 1px;
  opacity: 1;
}

/deep/ .el-carousel__indicators--horizontal {
  // bottom: 18px;
}

.guanbi {
  position: absolute;
  top: 8px;
  right: 8px;
  border: none;
  z-index: 9;
  background-color: transparent !important;
}

.content {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  font-size: 12px;
  // padding: 30px 50px 20px;
  color: $gj-font-color-grey8;
  font-weight: 400;
  line-height: 20px;

  .left54 {
    padding-left: 54px;
  }

  .dashed-line {
    height: 5px;
    border: 1px solid #D8DADD;
  }

  .img {
    width: 100%;
    box-shadow: 0px 2px 10px 0px rgba(230, 231, 232, 1);
    border-radius: 4px;
  }

  .cancel {
    position: absolute;
    right: 50px;
    bottom: 20px;
    width: 70px;
    height: 26px;
    padding: 4px 11px;
    line-height: 18px;
  }

  .colorBlue {
    color: $gj-hover-color-b5 !important;
  }


  .fw600 {
    font-weight: 600;
  }

  .font20 {
    font-size: 20px;
  }

  .font14 {
    font-size: 14px;
  }
}
</style>